import React, { useEffect, useState } from "react"
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom"
import PrivateRoute from "../components/PrivateRoute"
import Home from "../views/home"
import PrivateHeader from "../containers/PrivateHeader"
import enlaces from "../const/enlaces"
import SideBar from "../components/SideBar"
import Detail from "../views/herramientasPrestadas/detail"
import Documentos from "../views/carro/Documentos"
import { useLocalStorage } from "../hooks/useLocalStorage"
import { isJac } from "../utils/moduleAccess"

const PrivateRoutes = () => {
  const [rutas, setRutas] = useState([])
  const [permiso] = useLocalStorage("permiso", null)

  // Función para cargar las rutas
  const getRutas = () => {
    let preRutas = []
    enlaces.forEach((enlace, i) => {
      preRutas.push(
        <PrivateRoute
          exact
          key={i}
          component={enlace.vista}
          path={"/" + enlace.permiso}
          permisoCheck={enlace.permiso}
        />
      )
      // Definir las rutas de crear y editar por separado
      if (enlace.detail) {
        preRutas.push(
          <PrivateRoute
            exact
            key={`${i}-crear`}
            component={enlace.detail}
            path={"/" + enlace.permiso + "/crear"}
            permisoCheck={enlace.permiso}
          />
        )
        preRutas.push(
          <PrivateRoute
            exact
            key={`${i}-editar`}
            component={enlace.detail}
            path={"/" + enlace.permiso + "/editar/:id"}
            permisoCheck={enlace.permiso}
          />
        )
      }
    })
    setRutas([...preRutas])
  }

  useEffect(() => {
    getRutas()

    // Guardar la última ruta visitada en el localStorage
    const currentPath = window.location.pathname
    if (currentPath !== "/inicio") {
      localStorage.setItem("lastVisitedPath", currentPath)
    }
  }, [])

  // Recuperar la última ruta visitada al recargar
  useEffect(() => {
    const lastVisitedPath = localStorage.getItem("lastVisitedPath")
    if (lastVisitedPath && lastVisitedPath !== window.location.pathname) {
      if (window.location.pathname === "/inicio") {
        return
      }
      window.history.pushState(null, "", lastVisitedPath)
    }
  }, [])

  // Asegurarse de que las rutas se carguen correctamente
  if (!rutas || rutas.length === 0) {
    return <div>Cargando rutas...</div>
  }

  return (
    <Router>
      <SideBar />
      <PrivateHeader />
      <Switch>
        <PrivateRoute exact path="/carros/documentos/:id" permisoCheck="carros" component={Documentos} />
        {rutas}
        <Route exact path="/inicio" render={() => isJac(permiso) && (permiso.servicios & 1) ? <Redirect to="/servicios" /> : <Home />} />

        {/* La ruta del detalle debe ir al final para no interferir */}
        <PrivateRoute path="/herramientasPrestadas/detail/:id" permisoCheck="herramientasPrestadas" component={Detail} />

        {/* Solo redirigir al home si ninguna ruta es válida */}
        <Route path="*" component={() => <Redirect to="/inicio" />} />
      </Switch>
    </Router>
  )
}

export default PrivateRoutes
